import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  description: {
    fontSize: '14px',
    lineHeight: theme.spacing(2.5),
    color: theme.palette.labraText.description,
    fontWeight: 400,
    letterSpacing: theme.spacing(0.03125),
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
  },
  heading: {
    color: theme.palette.labraText.primary,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px',
    paddingBottom: theme.spacing(1),
  },
  subValue: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    paddingBottom: theme.spacing(3),
  },
  note: {
    width: 'fit-content',
  },
  numberOfDays: {
    width: theme.spacing(39),
  },
  numberOfDaysWrapper: {
    padding: theme.spacing(4, 0),
  },
  eulaWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  eulaDesc: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
}))
